import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

const img1 = require("../../devdata/screens/screen_1.png");
const img2 = require("../../devdata/screens/screen_2.png");
const img3 = require("../../devdata/screens/screen_4.png");
const images = [img1, img2, img3];

const AnimatedImageComponent = () => {
  const [index, setIndex] = useState(0);
  const [loopKey, setLoopKey] = useState(0); // Key to reset animation

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => prevIndex + 1);

      if (index === images.length - 1) {
        setTimeout(() => {
          setIndex(0);
          setLoopKey((prev) => prev + 1); // Forces re-render to restart animation
        }, 3000);
      }
    }, 300);
    return () => clearInterval(interval);
  }, [index]);

  return (
    <div
      key={loopKey}
      className="animation-container relative w-[579px] h-[600px] rounded-md "
    >
      {images.map((src, i) => (
        <motion.img
          key={i}
          src={src}
          alt={`image-${i}`}
          className="absolute w-[454px] h-[428px] rounded-xl"
          style={{
            zIndex: i, // Ensures layering
          }}
          initial={{ opacity: 0, x: 400 }} // Start off-screen (right)
          animate={{
            opacity: 1,
            x: i * 40,
            y: i * 40,
            scale: 1,
          }}
          transition={{
            duration: 0.8,
            ease: "easeInOut",
            delay: i * 0.5, // Staggered animation
          }}
        />
      ))}
      {/* Blur effect */}
      <motion.div
        className="absolute w-[50px] h-[580px] bg-black bg-opacity-15 blur-lg"
        style={{ top: 200, right: 250, rotate: "77deg" }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      />
    </div>
  );
};

export default AnimatedImageComponent;
